import React, { Component } from 'react';
import { Image } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { isTaskAvailable } from '../../utils';
import PayrollTransactionBase from '../Commons/PayrollTransactionBase';
import PayrollBankForm from './Forms/PayrollBankForm';

const ViewID = "PayrollBanks";
const ViewCaption = "Payroll Bank";

const userRightsKeys = {
    view: "PAYROLL_BANK_VIEW",
    create: "PAYROLL_BANK_CREATE",
    edit: "PAYROLL_BANK_EDIT",
    delete: "PAYROLL_BANK_DELETE",
}


class PayrollBankList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false
        }
        this.modalRef = React.createRef();
        this.parentRef = React.createRef();
    }

    createUrls = () => {
        return {
            search: "api/PayrollBank/search",
            setDeleted: "api/PayrollBank/setDeleted",
            save: "api/PayrollBank/save",
            load: "api/PayrollBank/load",
            // exportToExcel: "api/CustomTransactionType/exportToExcel",
        };
    }

    toCard = (model) => {
        return {
            _id: model._id,
            bankName: model.BankName,
            bankCode: model.BankCode,
            address: model.Address,
            companyAccountNumber: model.CompanyAccountNumber,
            contactPerson: model.ContactPerson,
            deleted: model.Deleted === null ? false : model.Deleted,
            editable: true,
            idle: false
        };
    };

    toModel = (card) => {
        return {
            _id: card.id,
            BankName: card.name,
            BankCode: card.bankCode,
            Address: card.address,
            CompanyAccountNumber: card.companyAccountNumber,
            ContactPerson: card.contactPerson,
        };
    };

    createFields = () => {
        // must have only one valueAs: 'header' and 'desciption',
        // 'content' can be none or many
        let fields = [
            { key: 'bankName', name: 'Bank Name', valueAs: 'header' },
            { key: 'bankCode', name: 'Bank Code', valueAs: 'description' },
            { key: 'address', name: 'Address', valueAs: 'content' },
            { key: 'companyAccountNumber', name: 'Account Number', valueAs: 'content' },
            { key: 'contactPerson', name: 'Contact Person', valueAs: 'content' },
        ];
        return fields;
    }

    validate = (data) => {
        var errTitle = "", errCaption = "";
        if (this.isNullOrEmpty(data.BankName)
            || this.isNullOrEmpty(data.BankCode)
            // || this.isNullOrEmpty(data.BranchCode)
        ) {
            errCaption = "Please fill up all required field/s";
            errTitle = "Invalid";
        }
        else {
            this.parentRef.current.setState({ showRequiredField: false });
            return true;
        }
        this.parentRef.current.setState({ showRequiredField: true, errTitle, errCaption });
        return false;
    };

    showModal = (data, visible) => {
        visible && this.modalRef.current.setContent(data);
        this.setState({ modalVisible: visible });
    }

    isNullOrEmpty(val) {
        if (val === null || val === undefined || val === "" || val.length === 0) return true;
        else return false;
    }

    render() {
        let self = this;
        return (
            <PayrollTransactionBase
                ref={this.parentRef}
                viewID={ViewID}
                title={ViewCaption}
                fields={this.createFields()}
                toModel={this.toModel}
                toCard={this.toCard}
                urls={this.createUrls()}
                validate={this.validate}
                props={this.props}
                showModal={this.showModal.bind(this)}
                userRightsKeys={userRightsKeys}
            // hasExportToExcel={true}
            >
                <PayrollBankForm
                    ref={self.modalRef}
                    open={self.state.modalVisible}
                    errTitle={self.parentRef.current ? self.parentRef.current.state.errTitle : ""}
                    errCaption={self.parentRef.current ? self.parentRef.current.state.errCaption : ""}
                    showRequiredField={self.parentRef.current ? self.parentRef.current.state.showRequiredField : ""}
                    isBusy={self.parentRef.current ? self.parentRef.current.state.isSaving : false}
                    onCancel={() => { 
                        self.setState({ modalVisible: false }, self.parentRef.current.setState({ showRequiredField: false })); 
                    }}
                    onSave={() => {
                        self.parentRef.current.saveFromModal(
                            self.modalRef.current.getContent()
                        );
                    }}
                />
            </PayrollTransactionBase>
        );
    }

}

PayrollBankList.getViewID = () => { return ViewID };
PayrollBankList.getCaption = () => { return ViewCaption }
PayrollBankList.getIcon = () => {
    // return (<Image style={{"height":"24px","width":"24px"}} src='Icons/customtransaction_small.png' avatar/>); 
    return (<Image style={{ "height": "24px", "width": "24px" }} src='/Icons/Payroll_Banks.png' avatar />);
}
PayrollBankList.getIconSrc = (size) => {
    // return 'Icons/tr_customtransaction_' + size + '.png' 
    return '/Icons/Payroll_Banks.png'
}
PayrollBankList.getViewAccessKey = function () {
    var count = Object.keys(userRightsKeys).filter(name => isTaskAvailable(userRightsKeys[name]) === true).length;
    return count > 0 ? true : false;
};
export default PayrollBankList